module.exports = __webpack_public_path__ + "img/companylogo8.2cd0c7ce.png";